import { create } from 'zustand';

export const useCategoryCreateStore = create((set) => ({
  isOpen: false,
  payload: {},
  callback: null, //
  openCategoryCreate: (payload,callback=null) => set({ isOpen: true, payload,callback }),
  close: (result) => set((state) => {
    // Call callback if exists, and clear everything
    if (state.callback) state.callback(result);
    return { isOpen: false, payload: {}, callback: null};
  }),
}));
export const openCategoryCreate = (payload) => {
  const store = useCategoryCreateStore.getState();
  store.openCategoryCreate(payload);
};

export const closeCategoryCreate = () => {
  const store = useCategoryCreateStore.getState();
  store.close();
};